import { render, staticRenderFns } from "./UPEditPopup.vue?vue&type=template&id=41392880"
import script from "./UPEditPopup.vue?vue&type=script&lang=js"
export * from "./UPEditPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports